import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

import RootComp from "./component/RootComp";
import EmailVerification from "./component/EmailVerification";
import SuccessMessage from "./component/SuccessMessage";

import Registration from "./widget/Registration";
import RegistrationSuccess from "./widget/RegistrationSuccess";
import ForgotPassword from "./widget/ForgotPassword";

import { DOMAIN_PARKER, DOMAIN_TFS, DOMAIN_BALDWIN, Context } from "./Constant";
import PasswordReset from "./widget/PasswordReset";
import ActivateAccount from "./widget/ActivateAccount";
import RequestAccess from "./widget/RequestAccess";
import RequestSuccess from "./widget/RequestSuccess";
import Approve from "./widget/Approve";
import Deny from "./widget/Deny";

import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';
import { getPath } from "./apiconfig";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domainName: "",
      langId: "-1",
    };
    this.getCookie = this.getCookie.bind(this);
  }

  componentDidMount() {
    let domainName = this.state.domainName;
    // removing cookie logic for domain names, causes issues when switching between domains
    /*const getDomainNameCookie = this.getCookie("appName");
    if (getDomainNameCookie !== "") {
      domainName =
        getDomainNameCookie === DOMAIN_TFS ? DOMAIN_TFS : getDomainNameCookie === DOMAIN_BALDWIN ? DOMAIN_BALDWIN : DOMAIN_PARKER;
    } else {
      const loc = window.location.href;
      domainName = loc.indexOf(DOMAIN_TFS) > -1 ? DOMAIN_TFS : loc.indexOf(DOMAIN_BALDWIN) > -1 ? DOMAIN_BALDWIN : DOMAIN_PARKER;
    } */
    const loc = window.location.href;
    domainName = loc.indexOf(DOMAIN_TFS) > -1 ? DOMAIN_TFS : loc.indexOf(DOMAIN_BALDWIN) > -1 ? DOMAIN_BALDWIN : DOMAIN_PARKER;
    document.title = domainName === DOMAIN_TFS ? "TFS" : domainName === DOMAIN_BALDWIN ? "Baldwin Filters" : "Parker";
    const getCookieLangId = this.getCookie("langId");
    const langId = getCookieLangId !== "" ? getCookieLangId : this.state.langId;
    this.setState({ domainName, langId });
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  render() {
    const {
      history,
      dispatch,
      updatePassword,
      emailAddress,
      localeText,
    } = this.props;

    const { domainName } = this.state;
    const loc = window.location.href.toLowerCase();
    let loginbgCls = "";
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    if (
      !(
        loc.indexOf("email-verification") > -1 ||
        loc.indexOf("updatepassword") > -1 ||
        loc.indexOf("success") > -1 ||
        loc.indexOf("passwordSuccess") > -1 
      )
    ) {
      loginbgCls =
        domainName === DOMAIN_PARKER
          ? "loginBackground"
          : domainName === DOMAIN_TFS
          ? "loginBackground_TFS"
          : domainName === DOMAIN_BALDWIN
          ? "loginBackground_baldwin"
          : "";
      if (msie > 0 && document.documentMode && document.documentMode > 9) {
        if (domainName === DOMAIN_PARKER) {
          if (document.body.className.indexOf("background-orange") === -1) {
            document.body.className += "background-orange";
          }
        } else if (domainName === DOMAIN_TFS || domainName === DOMAIN_BALDWIN) {
          if (document.body.className.indexOf("background-grey") === -1) {
            document.body.className += "background-grey";
          }
        }
      } else if (
        msie > 0 &&
        document.documentMode &&
        document.documentMode <= 9
      ) {
        document.body.className += "";
      } else {
        if (domainName === DOMAIN_PARKER) {
          if (document.body.className.indexOf("background-orange") === -1) {
            document.body.className += "background-orange";
          }
        } else if (domainName === DOMAIN_TFS || domainName === DOMAIN_BALDWIN) {
          if (document.body.className.indexOf("background-grey") === -1) {
            document.body.className += "background-grey";
          }
        }
      }
    } else {
      if (msie > 0) {
        document.body.className += "background-white";
      } else {
        document.body.classList.add("background-white");
      }
      
      if(loc.indexOf("request-success") >-1)
      {
        document.body.className += "background-orange";
        document.body.classList.add("background-orange");
      }
    }

    return (
      <Context.Provider
        value={{
          domainName: this.state.domainName,
          langId: this.state.langId,
          dispatch: this.props.dispatch,
          history: this.props.history,
        }}
      >
        <Context.Consumer>
          {({ domainName }) => (
            <div className={loginbgCls}>
              <Route
                exact
                path="/email-verification"
                render={(props) => (
                  <EmailVerification
                    history={history}
                    dispatch={dispatch}
                    localeText={localeText}
                  />
                )}
              />
              <Route
                exact
                path="/success"
                render={(props) => (
                  <SuccessMessage
                    history={history}
                    screen="1"
                    emailAddress={emailAddress}
                    localeText={localeText}
                  />
                )}
              />
              <Route
                exact
                path="/passwordSuccess"
                render={(props) => (
                  <SuccessMessage
                    history={history}
                    screen="2"
                    localeText={localeText}
                  />
                )}
              />
              <Route
                exact
                path="/request-success"
                render={(props) => <RequestSuccess history={history} />}
              />
              <Route
                exact
                path="/register"
                render={(props) => <Registration history={history} />}
              />
              <Route
                exact
                path="/request-access"
                render={(props) => <RequestAccess history={history} />}
              />
              <Route
                exact
                path="/activate-account"
                render={(props) => <ActivateAccount history={history} />}
              />
              <Route
                exact
                path="/registration-verification"
                render={(props) => <RegistrationSuccess history={history} />}
              />
              <Route
                exact
                path="/forgotpassword"
                render={(props) => <ForgotPassword history={history} />}
              />
              <Route
                exact
                path="/passwordreset"
                render={(props) => <PasswordReset history={history} />}
              />
              <Security issuer={getPath('redirectUrl')}
                  clientId={getPath('getApproverClientID')} 
                  redirectUri={window.location.origin + '/implicit/callback'}
                  scope="okta.groups.manage"
                  >
                <Route path="/implicit/callback" component={LoginCallback} />
                <SecureRoute path="/approve" component={Approve} />
                <SecureRoute path="/deny" component={Deny} />
              </Security>

              <Route
                exact
                path="/"
                render={(props) => (
                  <RootComp
                    history={history}
                    dispatch={dispatch}
                    updatePassword={updatePassword}
                    localeText={localeText}
                  />
                )}
              />
            </div>
          )}
        </Context.Consumer>
      </Context.Provider>
    );
  }
}

const myRouter = withRouter(App);

const mapStateToProps = (state) => ({
  emailAddress: state.emailAddress,
  updatePassword: state.updatePassword,
  localeText: state.localeText,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(myRouter);
